import { render, staticRenderFns } from "./workOfParty.vue?vue&type=template&id=052a262c&scoped=true"
import script from "./workOfParty.vue?vue&type=script&lang=js"
export * from "./workOfParty.vue?vue&type=script&lang=js"
import style0 from "./workOfParty.vue?vue&type=style&index=0&id=052a262c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052a262c",
  null
  
)

export default component.exports